import { useEffect, useState } from "react";
import styles from "../assets/styles/components/BackToTop.module.css";
import { FaAngleUp } from "react-icons/fa";

export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 200);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className={`${styles.backToTop} ${show ? styles.show : ""}`}
      onClick={scrollToTop}
    >
      <FaAngleUp />
    </div>
  );
}
